module.exports = __webpack_public_path__ + "img/7-1.8dbc9fdd.jpg";